import type { FC } from "react";
import { Resources } from "web_myplann/Infrastructure/Translations/Resources";
import { InspirationSliderSheet } from "web_myplann/Inspiration/Components/InspirationSliderSheet";
import {
	RETIREMENT_EXPENSES_DEFAULT,
	RETIREMENT_EXPENSES_MAX,
	RETIREMENT_EXPENSES_MIN,
	RETIREMENT_EXPENSES_STEP,
} from "web_myplann/Inspiration/Retirement/constants";

const S = Resources.Inspiration.Retirement.ExpensesSheet;

type Props = {
	open: boolean;
	onClose: () => void;
	onSubmit: (monthlyExpenses: number) => void;
	onOpenBalance: () => void;
};

export const RetirementExpensesSheet: FC<Props> = ({
	open,
	onClose,
	onSubmit,
	onOpenBalance,
}) => (
	<InspirationSliderSheet
		open={open}
		copy={S}
		hint={S.hint}
		secondaryLabel={S.openBalance}
		onSecondary={onOpenBalance}
		initial={RETIREMENT_EXPENSES_DEFAULT}
		min={RETIREMENT_EXPENSES_MIN}
		max={RETIREMENT_EXPENSES_MAX}
		step={RETIREMENT_EXPENSES_STEP}
		preventScrollOnClose
		onClose={onClose}
		onSubmit={onSubmit}
	/>
);
